module.exports = __webpack_public_path__ + "img/fitt_dark.92edd51c.svg";